export default __webpack_public_path__ + "static/media/full-screen-exit.02c2f14a.svg";